
import { useEffect, useState } from 'react';
import './../../App.css';
import inputData from '../../modules/inputData/inputData';

export default function Request_3(props){
    const checkItems = props.checkItems

    // Change Object
    let [dataObj, setDataObj] = useState({});
    const [selectedTypes, setSelectedTypes] = useState([]);
    const [selectedWorkTypes, setSelectedWorkTypes] = useState([]);

    // 종류 체크박스 핸들러
    const handleTypeChange = (value, checked) => {
        if (checked) {
            setSelectedTypes(prev => [...prev, value]);
        } else {
            setSelectedTypes(prev => prev.filter(item => item !== value));
        }
    };

    // 공종 체크박스 핸들러
    const handleWorkTypeChange = (value, checked) => {
        if (checked) {
            setSelectedWorkTypes(prev => [...prev, value]);
        } else {
            setSelectedWorkTypes(prev => prev.filter(item => item !== value));
        }
    };

    // EmailJS용 콤마 구분 문자열 생성
    useEffect(() => {
        inputData(setDataObj, 'r9_종류', selectedTypes.join(', '));
    }, [selectedTypes]);

    useEffect(() => {
        inputData(setDataObj, 'r9_공종', selectedWorkTypes.join(', '));
    }, [selectedWorkTypes]);

    return(
        <>
            <div className='form-header'>
                <ul>
                    <li style={{backgroundColor:'#f9e0d0'}}> 도면, 구조검토 견적 문의</li>
                </ul>
                <ul>
                    <li>구분</li>
                    <li>내용</li>
                </ul>
                <ul>
                    <li>종류</li>
                    <li>
                        {['도면', '구조검토'].map((a,i)=>{
                            return(
                                <label key={i} className='radio-wrap'>
                                    <input
                                    type="checkbox"
                                    name="r9_종류"
                                    value={a}
                                    checked={selectedTypes.includes(a)}
                                    onChange={(e) => handleTypeChange(a, e.target.checked)}
                                    /> <span>{a}</span>
                                </label>
                        )})}
                    </li>
                </ul>
                <ul>
                    <li>공종</li>
                    <li>
                        {['시스템 동바리', '시스템 비계', '강관 동바리', '강관 비계', '유로폼', 'RPP방음벽(파이프타입)', '달비계(공중비계)'].map((a,i)=>{
                            return(
                                <label key={i} className='radio-wrap'>
                                    <input
                                    type="checkbox"
                                    name="r9_공종"
                                    value={a}
                                    checked={selectedWorkTypes.includes(a)}
                                    onChange={(e) => handleWorkTypeChange(a, e.target.checked)}
                                    /> <span>{a}</span>
                                </label>
                        )})}
                    </li>
                </ul>
                <ul>
                    <li>특이사항</li>
                    <li>
                        <label>
                            <textarea
                                name="r9_특이사항"
                                rows="3"
                                placeholder="특이사항을 입력해주세요"
                                style={{
                                    width: '100%', 
                                    resize: 'vertical',
                                    fontSize: '16px',
                                    border: 'none',
                                    fontFamily: 'Noto Sans KR, sans-serif'
                                }}
                            />
                        </label>
                    </li>
                </ul>
            </div>
        </>
    )
}